import NiceModal from '@ebay/nice-modal-react'
import dynamic from 'next/dynamic'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Button, ButtonHierarchy } from '@/components/styleguide/Button'
import { selectIsAuthenticated } from '@/store/selectors/user'
import { Size } from '@/types/system'
import { isProd } from '@/lib/utilities/system'

const AuthenticationModal = dynamic(() => import('@/components/modals/AuthenticationModal'), {
  ssr: false,
})
const LoadModal = dynamic(() => import('@/components/modals/SaveSearchModals/LoadModal'), {
  ssr: false,
})

export const LoadTrigger = ({
  setIsMobileFiltersOpen,
}: {
  setIsMobileFiltersOpen?: (val: boolean) => void
}) => {
  const isAuthenticated = useSelector(selectIsAuthenticated)

  const onLoadSearchesClick = () => {
    if (setIsMobileFiltersOpen) {
      setIsMobileFiltersOpen(false)
    }

    if (isAuthenticated) {
      NiceModal.show(LoadModal as FC)
    } else {
      NiceModal.show(AuthenticationModal as FC)
    }
  }

  return (
    <Button
      size={Size.Medium}
      hierarchy={ButtonHierarchy.Borderless}
      label="Your saved searches"
      icon="ArrowRight"
      iconPosition="right"
      onClick={onLoadSearchesClick}
      className={!isProd() ? 'search__your-searches-button' : ''}
    />
  )
}
